import React from "react";
import { RouteComponentProps, withRouter } from "react-router-dom";
import Hidden from "@material-ui/core/Hidden";
import DesktopNavigator from "./DesktopNavigator";
import MobileNavigator from "./MobileNavigator";

const NavigationDrawer: React.FC<RouteComponentProps> = ({ location }: RouteComponentProps) => {
  return (
    <React.Fragment>
      <Hidden mdDown>
        <DesktopNavigator pathname={location.pathname} />
      </Hidden>
      <Hidden lgUp>
        <MobileNavigator pathname={location.pathname} />
      </Hidden>
    </React.Fragment>
  );
};

export default withRouter(NavigationDrawer);
